import React, { useState, useRef, useEffect } from 'react';

const ClicksignWidget = () => {
  const [requestSignatureId, setRequestSignatureId] = useState('');
  const [isLibraryLoaded, setIsLibraryLoaded] = useState(false); // Verifica se a biblioteca está carregada
  const widgetRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://cdn-public-library.clicksign.com/embedded/embedded.min-2.0.0.js';
    script.onload = () => {
      console.log('Biblioteca Clicksign carregada.');
      setIsLibraryLoaded(true); // Define que a biblioteca foi carregada
    };
    script.onerror = () => console.error('Erro ao carregar a biblioteca Clicksign.');
    document.body.appendChild(script);

    return () => {
      if (widgetRef.current) {
        widgetRef.current.unmount();
      }
    };
  }, []);

  const loadWidget = () => {
    if (!isLibraryLoaded) {
      console.error('A biblioteca Clicksign ainda não foi carregada.');
      return;
    }

    if (!requestSignatureId) {
      console.error('ID de assinatura solicitado não fornecido.');
      return;
    }

    if (!containerRef.current) {
      console.error('Contêiner não encontrado no DOM.');
      return;
    }

    // Desmontar widget antigo, se necessário
    if (widgetRef.current) {
      widgetRef.current.unmount();
    }

    try {
      // Verifique explicitamente a disponibilidade de `window.Clicksign`
      if (!window.Clicksign) {
        console.error('Clicksign não está disponível no escopo global.');
        return;
      }

      // Inicializar widget
      widgetRef.current = new window.Clicksign(requestSignatureId);
      widgetRef.current.endpoint = 'https://sandbox.clicksign.com';
      widgetRef.current.origin = "*";

      // Montar no contêiner
      widgetRef.current.mount(containerRef.current);
      console.log('Widget montado com sucesso.');

      // Configurar eventos
      widgetRef.current.on('loaded', () => console.log('Widget carregado!'));
      widgetRef.current.on('signed', () => console.log('Assinado!'));
      widgetRef.current.on('resized', (event) => {
        console.log('Widget redimensionado.');
        containerRef.current.style.height = `${event.data.height}px`;
      });
    } catch (error) {
      console.error('Erro ao montar o widget:', error);
    }
  };

  return (
    <div>
      <input
        type="text"
        value={requestSignatureId}
        onChange={(e) => setRequestSignatureId(e.target.value)}
        placeholder="Enter Request Signature ID"
      />
      <button onClick={loadWidget}>Load</button>
      <div ref={containerRef} style={{ height: '600px' }}></div>
    </div>
  );
};

export default ClicksignWidget;
